const HEX = /^#[0-9a-f]{6}$/i

/** Null means the portal keeps its built-in background, so only a full hex color is saved. */
export function parseBackgroundColor(value: string): string | null | undefined {
	const trimmed = value.trim()
	if (trimmed === "") return null
	return HEX.test(trimmed) ? trimmed.toUpperCase() : undefined
}
